import { Routes } from '@angular/router';
import { CrowdAwsAnnotatorComponent } from '../components/crowd-aws-annotator/crowd-aws-annotator.component';
import { MainComponent } from '../components/main/main.component';

export const routes: Routes = [
  {path: '', component: MainComponent},
  {path: 'crowd-aws-annotator/:jobId', component: CrowdAwsAnnotatorComponent}
];